module.exports = __webpack_public_path__ + "kz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kz.svg
// module id = 652
// module chunks = 0